export default __webpack_public_path__ + "static/media/free.eb4b86a6.mp4";